module.exports = __webpack_public_path__ + "img/loginhenrydos.bfc215d9.png";